import React, { useEffect, useState, useRef } from "react";
import "@css/ThreeText.css";
import { getHomeNews, getProductContact, getProduct3Dvs } from "../utils";
import { Link } from "react-router-dom";
import loading from "@images/loading.png";

const Text = (props) => {
  const { home } = props;
  const [news, setNews] = useState([]);
  const [load, setLoad] = useState("");
  const [winUrlSplit, setWinUrlSplit] = useState('');
  const path = window.location.href;
  const isMounted = useRef(true);
  const onclickRoute = () => {
    if (home === 0) {
      localStorage.setItem("route", "home");
    } else {
      return localStorage.setItem("route", "product");
    }
  };
  useEffect(() => {
    const winUrl = window.location.href;
    const winUrlSplit = winUrl.split('/')[3];
    setWinUrlSplit(winUrlSplit)
  }, [window.location])
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    setLoad(false);
    if (path.split('/')[3] === 'product?contact') {
      getProductContact()
      .then((res) => {
        if (isMounted.current && !res.Message) {
          setNews(res.Data);
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoad(true);
        }
      });
    } else if (path.split('/')[3] === 'product?3dvs') {
      getProduct3Dvs()
      .then((res) => {
        if (isMounted.current && !res.Message) {
          setNews(res.Data);
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoad(true);
        }
      });
    } else {
      getHomeNews()
        .then((res) => {
          if (isMounted.current && !res.Message) {
            setNews(res.Data);
          }
        })
        .finally(() => {
          if (isMounted.current) {
            setLoad(true);
          }
        });
    }
  }, [path]);
  return (
    <div className="news"
    // onClick={() => onclickRoute()}
    >
      {load ? (
        <div className="news_text">
          {news.map((item, i) => {
            return (
              <div key={i}>
                <Link to={`/detail/${item.Id}?type=${winUrlSplit}`} target="_blank">
                  <img src={item.FullThumbImage} alt="" />
                  <div className="news_text_box">
                    <h1>{item.NewsTitle}</h1>
                    {
                      document.body.clientWidth < 900&&(
                        <p>{item.NewsDesc}</p>
                      )
                    }
                    {
                      document.body.clientWidth > 1000&&(
                        <p>{item.NewsDesc}</p>
                      )
                    }
                    
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="threeTextLoading">
          <img src={loading} alt="" />
          <p>加载中...</p>
        </div>
      )}
    </div>
  );
};

export default Text;
